import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {prism as prismStyle} from 'react-syntax-highlighter/dist/esm/styles/prism';

/**
 * PrismSyntaxHighlighter Component
 * A React component for highlighting code using the Prism library.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {string} props.language - The language for syntax highlighting
 * @param {string} props.code - The code to be highlighted
 * @returns {JSX.Element} - The rendered component
 */
const PrismSyntaxHighlighter = memo(({
                                         language,
                                         code,
                                         style = {}
                                     }) => {
    const TAG = 'PrismSyntaxHighlighter';
    return <div className={'rounded-3 overflow-hidden'}>
        <SyntaxHighlighter
            className={'m-0 text-wrap text-break flex-wrap text-break-space'}
            language={language}
            style={{...prismStyle, ...style}}
        >{code}</SyntaxHighlighter>
    </div>
});

PrismSyntaxHighlighter.propTypes = {
    language: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
};

export default PrismSyntaxHighlighter;
